export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '대상연월'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).headerDateString // 대상연월
      case 2: return func.getContent(value).stdInfo.department // 소속명
      case 3: return func.getContent(value).stdInfo.section // 부서명
      case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    nav.conditions = []
    if (nav.value.created_at) {
      if (nav.value.created_at.sDate) {
        nav.conditions.push({
          operator: ">=",
          value: nav.value.created_at.sDate,
          key: "body.headerDate",
        })
      }
      if (nav.value.created_at.eDate) {
        nav.conditions.push({
          operator: "<=",
          value: nav.value.created_at.eDate,
          key: "body.headerDate",
        })
      }
    }
    if (nav.value.searchKeyword) {

      let key = ''
      switch (nav.value.stype) {
      case '사업장명': key = 'body.stdInfo.field_name'; break;
      case '대상연월': key = 'body.headerDate'; break;
      case '소속명': key = 'body.stdInfo.department'; break;
      case '부서명': key = 'body.stdInfo.section'; break;
      case '작성자': key = 'body.stdInfo.writer_name'; break;
      }

      nav.conditions.push({
        operator: "LIKE",
        value: `%${nav.value.searchKeyword}%`,
        key,
      })
    }
    return { conditions: nav.conditions };
  },
  getSearchKeyword: (nav) => [],
}
